import script from "./team-detail-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./team-detail-modal.vue?vue&type=script&setup=true&lang=js"

import "./team-detail-modal.vue?vue&type=style&index=0&id=0e37c725&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e37c725"]])

export default __exports__